const getQuotaPercentage = (current, quota) => {
  const percentage = Number(current / quota * 100).toFixed(2);
  return current && percentage <= 1 ? 1 : percentage;
};

export default getQuotaPercentage;
